export class Column {
  left: any[] = [];
  right: any[] = [];
  middle: any[] = [];
}

export class Row<T> {
  leftItem: T;
  rightItem: T;
  middle: T;
}

export interface IColumnSortable {
  columns: ColumnType;
}

export type ColumnType = 'single' | 'double';



// WEBPACK FOOTER //
// ./src/app/models/_shared/column.model.ts